import clsx from "clsx";
import type { ReactNode } from "react";

export default function Container({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx("mx-auto w-full max-w-shell px-4 sm:px-6", className)}
    >
      {children}
    </div>
  );
}
